import type { ReactNode } from "react";
import { SafeAreaLayout } from "./SafeAreaLayout";

// 전체 앱 셸 — statusbar(웹에선 헤더 영역 placeholder) + content scroll
// 페이지별 accent는 body[data-page] 속성으로 분기
interface Props {
  // IA 재편 §2 — 새 5탭 + 금융 탭 하위(budget·asset·mbti·signature)
  page?:
    | "home" | "finance" | "games" | "community" | "my"
    | "budget" | "asset" | "mbti" | "signature";
  children: ReactNode;
}

export function AppLayout({ page, children }: Props) {
  // body data-page 동기화 (페이지별 accent CSS 변수 분기)
  if (typeof document !== "undefined") {
    if (page) document.body.setAttribute("data-page", page);
    else document.body.removeAttribute("data-page");
  }

  return (
    <SafeAreaLayout>
      <div className="app-layout">{children}</div>
    </SafeAreaLayout>
  );
}
